import { Dispatch } from "redux";
import * as actions from "./actions";
import { Widgets } from "./types";
import { ProviderRating, Provider as ProviderType } from './types';
import { WidgetPageType } from "../state/types";

/*
  Promises for reviews side-functions
*/

export const getReviews = (dispatch: Dispatch, filter: string) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.getReviews(filter, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const getReviewsFiltered = (dispatch: Dispatch, query: string, idDealer: string) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.getReviewsFiltered(query, idDealer, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const getReviewsConfig = (dispatch: Dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.getReviewsConfig((result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const saveWidgetsConfig = (dispatch: Dispatch, widgets: Widgets) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.saveGetWidgetsConfig(widgets, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const publishWidgetsConfig = (dispatch: Dispatch, widgetsPublish: Widgets, selectedTab: WidgetPageType) => {
  return new Promise((resolve, reject) => {
    dispatch(actions.saveGetWidgetsPublish(widgetsPublish, selectedTab, (result, error) => {
      if (error) reject(error);
      else resolve(result);
    }));
  });
}

export const getIsSelected =  (providerSearch: ProviderRating, selectedTab: string, widgets: Widgets|undefined, widgetName: string) => {
  if (selectedTab === "entire" && widgets && (widgetName === "leaveReview" || widgetName === "providersRating") &&
      widgets.entireConfig[widgetName].providers.find((provider: ProviderType) =>  provider.name.toLowerCase()===providerSearch.provider.toLowerCase()))
      return true
  else if (selectedTab === "entire" && widgets && 
    widgets.entireConfig[widgetName].providers.find((provider: ProviderType) =>  provider.name.toLowerCase()===providerSearch.provider.toLowerCase() && providerSearch.totalReviews>0))
    return true
    
  if (selectedTab === "individual" && widgets && (widgetName === "leaveReview" || widgetName === "providersRating") &&
      widgets.individualConfig[widgetName].providers.find((provider: ProviderType) =>  provider.name.toLowerCase()===providerSearch.provider.toLowerCase()))
      return true
  else if (selectedTab === "individual" && widgets &&
      widgets.individualConfig[widgetName].providers.find((provider: ProviderType) =>  provider.name.toLowerCase()===providerSearch.provider.toLowerCase() && providerSearch.totalReviews>0))
      return true
  return false;
}

/*
  Utils to create queries for COSMOS DB
*/

export const capitalizeFirstLetter = (text?: string) => {
  if (!text) return "";
  if (text[0]) text = text[0]?.toUpperCase() + text.substring(1)?.toLowerCase();
  return text;
}

export const searchContainedValues = (params: {key: string; value: string;}[]) => {
  const filters = params.map(param => `CONTAINS (LOWER(c.${param.key}), "${param.value.toLowerCase()}")`);
  return `(${filters.join(" or ")})`;
}

/*
  Functions
*/

export const getFixedOpacity = (opacity?: number) => {
  if (typeof opacity === "number" && opacity >= 0) return opacity;
  return 100;
}

export const componentToHex = (c: number) => {
  var hex = Math.ceil(c).toString(16);
  return hex.length == 1 ? "0" + hex : hex;
}

export const createRGBA = (color?: string, opacity?: number) => {
  let newColor = color;
  let newOpacity = componentToHex(getFixedOpacity(opacity) / 100 * 255);
  if (!newColor) newColor = "#FFFFFF";
  return `${newColor}${newOpacity}`;
}

export const logFunction = (x: number, a?: number, b?: number, c?: number) => {
  return (a ?? 1) * Math.log(x) / (b ? Math.log(b) : 1) + (c ?? 0);
}